import styled from 'styled-components'
import Modal from 'modals/dialog'

export const ModalBody = styled(Modal.Body)`
    user-select: none;
`